import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { LubavButton } from '@backrs_ui/grow-ui/src/components/Lubav/LubavButton';

import { Box, SxProps, Theme, Typography } from '@mui/material';

const STRINGS = appStrings.modules.myColleges.awardLetter.ask;

type AwardLetterAskLubavProps = Readonly<{ collegeName: string; hasScholarship: boolean }>;

export const AwardLetterAskLubav = ({ collegeName, hasScholarship }: AwardLetterAskLubavProps) => (
  <Box id="award-letter-lubav-checks" sx={containerSx}>
    <Typography variant="text-sm-medium">{STRINGS.title}</Typography>
    <Box sx={buttonsSx}>
      <LubavButton
        id="award-letter-ask-loans-separate"
        label={STRINGS.loansSeparate}
        prompt={STRINGS.loansSeparatePrompt(collegeName)}
      />
      <LubavButton
        id="award-letter-ask-parent-plus"
        label={STRINGS.parentPlus}
        prompt={STRINGS.parentPlusPrompt(collegeName)}
      />
      <LubavButton
        id="award-letter-ask-cost-of-attendance"
        label={STRINGS.costOfAttendance}
        prompt={STRINGS.costOfAttendancePrompt(collegeName)}
      />
      {hasScholarship && (
        <LubavButton
          id="award-letter-ask-keep-scholarship"
          label={STRINGS.keepScholarship}
          prompt={STRINGS.keepScholarshipPrompt(collegeName)}
        />
      )}
    </Box>
  </Box>
);

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-md'],
});

const buttonsSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: backrs.spacing['spacing-sm'],
});
